import * as LinksDTOs from "./LinksDTOs.js";
import * as TipoObjeto from "../../constantes/TipoObjeto.js";

export const ItemVacio = (idPadre) => {
  return LinksDTOs.ItemVacio(TipoObjeto.CLUB, idPadre);
};

export const saveItem = (item) => {
  return LinksDTOs.saveItem(item);
};
